var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 409.6 409.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e98c7",
    d: "M324.265 240.65V34.135C324.265 15.36 308.9 0 290.135 0H51.2C32.435 0 17.065 15.36 17.065 34.135v307.2c0 18.765 15.37 34.13 34.135 34.13h188.134c15.565 20.618 40.049 34.135 67.866 34.135 47.114 0 85.335-38.216 85.335-85.335 0-41.277-29.332-75.694-68.27-83.615zm-34.13 0c-38.932 7.921-68.27 42.337-68.27 83.615 0 5.852.599 11.551 1.736 17.07H51.2v-307.2h238.935V240.65zm68.265 96.415h-64V273.07H320v38.395h38.4v25.6z",
    "data-original": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e98c7",
    d: "M85.335 204.8H221.865V238.93H85.335z",
    "data-original": "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e98c7",
    d: "M85.335 273.05H187.735V307.18H85.335z",
    "data-original": "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e98c7",
    d: "M85.335 136.535H255.985V170.67H85.335z",
    "data-original": "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e98c7",
    d: "M85.335 68.265H221.865V102.4H85.335z",
    "data-original": "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.4299bfd56ee97f4df85c612b1c23e0cb.svg";
export { ForwardRef as ReactComponent };